import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";
import { css } from "styled-components/macro"; //eslint-disable-line
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithInput.js";
import Features from "components/features/ThreeColWithSideImage.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
import FeatureWithSteps from "components/features/TwoColWithSteps.js";
import FAQ from "components/faqs/SingleCol.js";
import GetStarted from "components/cta/GetStarted";
import Footer from "components/footers/FiveColumnWithBackground.js";
import macHeroScreenshotImageSrc from "images/stepsToInstall.png";
import prototypeIllustrationImageSrc from "images/prototype-illustration.svg";

export default function App() {
  
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
  const HighlightedText = tw.span`text-primary-500`;
  return (
    <AnimationRevealPage disabled>
      <Hero/>
      <Features 
        subheading={<Subheading>INNOVATION</Subheading>}
        heading={
          <>
            How it compares<br />to <HighlightedText>existing solutions.</HighlightedText>
          </>
        }
        imageDecoratorBlob={true}
      />
      <MainFeature
        subheading={<Subheading>Prototype</Subheading>}
        />
      <FeatureWithSteps
        subheading={<Subheading>Ease of Use</Subheading>}
        heading={
          <>
            Steps to <HighlightedText>Install</HighlightedText>
          </>
        }
        textOnLeft={false}
        imageSrc={macHeroScreenshotImageSrc}
        imageDecoratorBlob={true}
        decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-15 -translate-x-1/2 left-1/2`}
      />
      <MainFeature2
      
        subheading={<Subheading>SOURCES</Subheading>}
        heading={
          <>
            <HighlightedText>Principle</HighlightedText> sources of information.
          </>
        }
        imageSrc={prototypeIllustrationImageSrc}
        showDecoratorBlob={false}
      />
      {/* <Testimonial
        subheading={<Subheading>Testimonials</Subheading>}
        heading={
          <>
            Our Clients <HighlightedText>Love Us.</HighlightedText>
          </>
        }
        testimonials={[
          {
            stars: 5,
            profileImageSrc:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3.25&w=512&h=512&q=80",
            heading: "Amazing User Experience",
            quote:
              "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",
            customerName: "Charlotte Hale",
            customerTitle: "Director, Delos Inc."
          },
          {
            stars: 5,
            profileImageSrc:
              "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80",
            heading: "Love the Developer Experience and Design Principles !",
            quote:
              "Sinor Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
            customerName: "Adam Cuppy",
            customerTitle: "Founder, EventsNYC"
          }
        ]}
      /> */}
      <FAQ
        subheading={<Subheading>FAQS</Subheading>}
        heading={
          <>
            You have <HighlightedText>Questions ?</HighlightedText>
          </>
        }
        faqs={[
          {
            question: "What do you need from us?",
            answer:
              "This will be a fully developed system that requires a little marketing. We believe that this tool can serve many groups of people and different types of people should be aware of what this tool has to offer. And we can allow government organizations to access the chaotic information example : the caps caused at Bandra station due to the misleading information about train functionality for workers , legal authority could take action."
          },
          {
            question: "When do you think a product would be ready ?",
            answer:
              "Our team has developed a working prototype, so it will not be long until we can refine the rough edges of the model."
          },
          {
            question: "How do you plan to train your model?",
            answer:
              "The app will be using information from approved databases such as WHO, CDC, NIH. And the information would be updated automatically through java script even if the website contains new questions"
          },
          {
            question: " Why would a person want to use this assistant? ",
            answer:
              "Our assistant drastically changes the way of fact checking and isn't platform specific either . To make fact checking as behaviour we have introduced a rewarding system for every time the fact has been checked , who wouldn't love rewards"
          },
          {
            question: "Who are our partners?",
            answer:
              "Approved databases that publish accurate scientific findings would be a key player in our app, especially because we would use their information to check whether or not the information presented over social media is true."
          },
          {
            question: "What sets this apart from every other AI in this competition?",
            answer:
              "The AI can always be improved in performance and perfection. The way it's presenting the information is the catch and how fast and easy it would make this process."
          },
          {
            question: "Do you see any limitations of this project?",
            answer:
              "Unfortunately, due to the complexity of the AI system, rural communities will have a harder time downloading the application, in no time they'll learn to use it."
          }
        ]}
      />
      <GetStarted/>
      <Footer />
    </AnimationRevealPage>
  );
}
